// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__mXMbm","colCheckbox":"styles_colCheckbox__FXKgE"};